import {
  AccountContainer,
  AccountBox,
  AccountButton,
  AccountIn,
  AccountSecondDiv,
  AccountFirstBox,
  AccountSecondBox,
  AccountImgOne,
  AccountImgTwo,
  CreateAccount,
  CreateCurve,
  CreateCircle,
  CreateGuideOne,
  CreateGuideTwo,
} from "./AccountCreation.styled";
import arrow from "../../assets/icons/arrow.png";
import { vector01, vector02 } from "../../../public/assets";

const AccountCreation = () => {
  return (
    <AccountContainer>
      <AccountBox>
        <AccountButton>
          <p className="btn_creation">ACCOUNT CREATION</p>
        </AccountButton>

        <CreateAccount>
          <h4>
            Four simple steps to create <br /> an account
          </h4>
          <p>Create your account in just four simple steps</p>
        </CreateAccount>
      </AccountBox>

      <CreateCurve>
        <div className="AccountImgFirstDiv">
          <CreateCircle>
            <span>1</span>
            <span>2</span>
          </CreateCircle>
          <img src="/assets/icons/Vector1.png" alt="" />

          <AccountFirstBox>
            <AccountImgOne>
              <AccountIn>
                <div className="account_creation_circle mobile">
                  <span className="first_span">1</span>
                </div>
                <img className="img_1" src="/assets/icons/arrow.png" alt="" />
              </AccountIn>
              <CreateGuideOne>
                <h6 className="an_account">Create an account </h6>
                <p className="click_create">
                  Use our easy and quick <br />
                  registration process
                </p>
              </CreateGuideOne>
            </AccountImgOne>

            <AccountImgTwo>
              <AccountIn>
                <div className="account_creation_circle mobile">
                  <span className="second_span">2</span>
                </div>
                <img className="img_2" src="/assets/icons/arrow.png" alt="" />
              </AccountIn>
              <CreateGuideTwo>
                <h6 className="fill_details">Fill in your details</h6>
                <p className="relevant_details">
                  Provide all relevant details and <br />
                  information to get started
                </p>
              </CreateGuideTwo>
            </AccountImgTwo>
          </AccountFirstBox>
        </div>

        <div className="AccountImgSecondDiv">
          <CreateCircle>
            <span>3</span>
            <span>4</span>
          </CreateCircle>
          <img src="/assets/icons/Vector2.png" alt="" />
          <AccountSecondBox>
            <AccountImgOne>
              <AccountIn>
                <div className="account_creation_circle mobile">
                  <span className="third_span">3</span>
                </div>
                <img className="img_3" src="/assets/icons/arrow.png" alt="" />
              </AccountIn>
              <CreateGuideOne>
                <h6 className="verify_confirm">
                  Verification and <br /> confirmation
                </h6>
                <p className="confirm_email">
                  Verify and confirm your email <br /> address and relevant
                  documents
                </p>
              </CreateGuideOne>
            </AccountImgOne>

            <AccountImgTwo>
              <AccountIn>
                <div className="account_creation_circle mobile">
                  <span className="fourth_span">4</span>
                </div>
                <img className="img_4" src="/assets/icons/arrow.png" alt="" />
              </AccountIn>

              <CreateGuideTwo>
                <h6 className="get_started">Get started</h6>
                <p className="enjoy_explore">
                  Enjoy and explore all the <br /> services Fipay has to offer
                </p>
              </CreateGuideTwo>
            </AccountImgTwo>
          </AccountSecondBox>
        </div>
      </CreateCurve>

      <AccountSecondDiv></AccountSecondDiv>
    </AccountContainer>
  );
};

export default AccountCreation;
